import React, { useEffect, useState } from "react";
import OverallComplianceStatusCharts from "./OverallComplianceStatusCharts";
import DashboardCharts from "./DashboardCharts";
import { Button } from "react-bootstrap";
import Icon from "../../../common/Icon";
import { useExportComplianceDashbard } from "../../../../backend/compliance";
import { copyObject, downloadFileContent } from "../../../../utils/common";
import { toast } from "react-toastify";
import { ERROR_MESSAGES } from "../../../../utils/constants";
import { DEFAULT_PAYLOAD } from "./../../../common/Table";
import PageLoader from "../../../shared/PageLoader";
import { setUserDetailsInFilters } from "../../../../constants/Compliance.constants";
import { hasUserAccess } from "../../../../backend/auth";
import { USER_PRIVILEGES } from "../../UserManagement/Roles/RoleConfiguration";
import { useGetComplianceDashboardChartsStats } from "../../../../backend/compliance";

export default function ComplianceDashboardCharts({ filters }: any) {
    const isEscalationManager = hasUserAccess(USER_PRIVILEGES.ESCALATION_DASHBOARD);
    const [ complianceStats, setComplianceStats ] = useState<any>({});
    const [ categoryStats, setCategoryStats ] = useState<any>({});
    const { exportDashboard, exporting }: any = useExportComplianceDashbard((response: any) => {
        downloadFileContent({
            name: `ComplianceDashboardCharts_${new Date().toLocaleString()}.pdf`,
            type: response.headers['content-type'],
            content: response.data
        });
    }, () => {
        toast.error(ERROR_MESSAGES.DEFAULT)
    });

    const { stats, isFetching } = useGetComplianceDashboardChartsStats({
        filters: filters
    }, hasFilters(filters, 'compliance_manager_id_eq') || hasFilters(filters, 'compliance_manager_id_in') || hasFilters(filters, 'compliance_owner_id_eq'));

    function enableActivities() {
        const _filters = setUserDetailsInFilters(copyObject(filters))
        const hasCompany = hasFilters(_filters);
        const hasStartDate = hasFilters(_filters, 'start_date_gteq');
        return isEscalationManager ? hasCompany && hasStartDate : hasStartDate;
    }

    function hasFilters(ref: any, field = 'company_id_eq') {
        const column = (ref || {})[field];
        return Boolean(column);
    }

    function handleExport() {
        if (enableActivities()) {
            exportDashboard({ ...DEFAULT_PAYLOAD, filters: setUserDetailsInFilters(filters), pagination: null })
        }
    }

    useEffect(() => {
        if(stats && !isFetching) {
            setComplianceStats({
                overall: stats.overall_compliance_status,
                notices: stats.notice_compliance_status
            })
            setCategoryStats(stats.status_by_category)
        }
    }, [isFetching])

    return (
        <>
            {/* hide export button ticket ref- 101 */}
            {false && <div className="d-flex flex-row mx-2 mb-3">
                <Button variant="primary" onClick={handleExport} disabled={!enableActivities()}> <Icon name="download" /> Export</Button>
            </div>}
            <div className="d-flex flex-column card shadow p-3 mx-2 mb-3">
                <OverallComplianceStatusCharts data={complianceStats}/>
            </div>
            <div className="d-flex flex-column card shadow p-3 mx-2">
                <DashboardCharts data={categoryStats}/>
            </div>
            {
                exporting && <PageLoader message="Preparing data..." />
            }
        </>
    )
}